import { render, staticRenderFns } from "./templates.vue?vue&type=template&id=6d79fe11&scoped=true"
import script from "./templates.vue?vue&type=script&lang=ts"
export * from "./templates.vue?vue&type=script&lang=ts"
import style0 from "./templates.vue?vue&type=style&index=0&id=6d79fe11&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d79fe11",
  null
  
)

/* custom blocks */
import block0 from "./templates.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports